module.exports = __webpack_public_path__ + "assets/img/card_savoiemb.281b7ad8.jpg";